import type { MessageObject } from '../../types/inbox'
import { sanitizeHtml } from '../../utils/sanitize-html'
import SendTime from './send-time'

// The body of a single opened message (subject + time + content). Shared by the
// /profile/inbox page and the inbox modal so both read identically.
const MessageDetail = ({ message }: { message: MessageObject }) => (
  <div className="bg-secondary rounded-xl py-4 px-4">
    <div className="flex items-start justify-between gap-3">
      {/* Title — wraps in full here, this is the whole message */}
      <div className="text-sm xl:text-base leading-5 font-semibold font-[Poppins] text-highlight-gold">
        {message.subject}
      </div>
      <SendTime value={message.send_time} className="text-[11px]" />
    </div>
    <div className="h-px my-3 bg-secondary-txt-20" />
    {/* Message Content */}
    <div
      dangerouslySetInnerHTML={{ __html: sanitizeHtml(message.content) }}
      className="text-sm xl:text-base text-txt leading-[22px] font-normal font-[Poppins] [&_a]:text-highlight-gold [&_a]:underline [&_p]:mb-2 [&_p:last-child]:mb-0"
    />
  </div>
)

export default MessageDetail
